// extracted by mini-css-extract-plugin
export default {"profileWrap":"Profile_profileWrap__xjrLS"};